/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export default class Invitation extends Entity {
  static isValidGroupInvite(groupId, address) {
    return apiRequest(`/classes/${groupId}/invitations/validate`, 'GET', {
      invitations: [
        {
          address,
        },
      ],
    });
  }

  static isValidOrgInvite(orgId, address) {
    return apiRequest(`/managed_orgs/${orgId}/invitations/validate`, 'GET', {
      invitations: [
        {
          address,
        },
      ],
    });
  }
}



// WEBPACK FOOTER //
// ./src/entities/Invitation.js